import { IAdvancedStore } from '@mihanizm56/redux-core-modules';
import { Router } from 'router5';
import { loadScript } from '@/api/requests/load-script';
import { loadStyle } from '@/api/requests/load-style';

type ParamsType = {
  store: IAdvancedStore;
  router: Router;
};

export const fetchExternalPackages = async ({ store, router }: ParamsType) => {
  try {
    // eslint-disable-next-line no-underscore-dangle
    const externalPackagesModules = window.__EXTERNAL_PACKAGES_MODULES__;

    await Promise.all(
      externalPackagesModules.map(async (moduleUrl: string) => {
        const loadScriptUrl = `${moduleUrl}/index.js`;
        const loadCSSUrl = `${moduleUrl}/index.css`;

        await Promise.all(
          [loadCSSUrl, loadScriptUrl].map(async (item) => {
            try {
              if (item.includes('.css')) {
                loadStyle('', '', item, true);

                return;
              }

              const {
                externalPackages,
                registrationSaga,
                registrationReducer,
                registrationDependencies,
                registrationActions,
              } = await loadScript('', '', loadScriptUrl, true);

              if (externalPackages) {
                store.setDependencies({
                  ...store.dependencies,
                  externalPackages: {
                    ...store.dependencies?.externalPackages,
                    ...externalPackages,
                  },
                });
              }

              if (registrationActions) {
                registrationActions();
              }

              if (registrationSaga) {
                registrationSaga({ store });
              }

              if (registrationReducer) {
                registrationReducer({ store });
              }

              if (registrationDependencies) {
                registrationDependencies({ store, router });
              }
            } catch (error) {
              console.error(
                `Load ext packages module "${loadScriptUrl}" get an error`,
                error,
              );
            }
          }),
        );
      }),
    );
  } catch (error: any) {
    console.error(
      'fetchExternalPackagesWorkerSaga get an error',
      error.message,
    );
  }
};
